<template>
  <div class="submit">
    <Adress />
    <div class="goods">
      <div class="sy-cell goods-item">
        <img src="https://file.36krcdn.com/20190623/v2_1561302515667_file_000" class="goods-img">
        <div class="goodtext">
          <div class="title">
            心美特   Fora   xxxxxxxxxxxxxxxxxxxxx
          </div>
          <div class="goods-sku">
            Fora  型号说明
          </div>
          <div class="money">
            <span class="font9">￥</span>199
          </div>
        </div>
      </div>
      <div class="sy-cell_between pab30">
        <div class="name">
          购买数量
        </div>
        <div class="num">
          <van-stepper v-model="value" />
        </div>
      </div>
      <div class="sy-cell_between pab30">
        <div class="name">
          配送方式
        </div>
        <div class="name">
          快递免邮
        </div>
      </div>
      <div class="sy-cell textarea-box">
        <div class="name">
          卖家留言：
        </div>
        <div class="name">
          <van-field v-model="remeak" placeholder="填写内容已和卖家沟通确认" type="textarea" />
        </div>
      </div>
    </div>
    <div class="goods2">
      <div class="sy-cell_between pab30">
        <div class="name">
          商品金额
        </div>
        <div class="money">
          ￥407.80
        </div>
      </div>
      <div class="sy-cell_between pab30">
        <div class="name">
          运费
        </div>
        <div class="money">
          ￥0.00
        </div>
      </div>
    </div>
    <div class="sy-cell footer">
      <van-submit-bar
        :price="3050"
        button-text="立即付款"
        @submit="onSubmit"
      />
    </div>
  </div>
</template>
<script>
import Adress from './components/adress'
export default {
  name: 'Submit',
  components: {
    Adress
  },
  data() {
    return {
      value: 1,
      remeak: ''
    }
  },
  methods: {
    onSubmit() {
      this.$router.push('/order/orderList')
    }
  }
}
</script>
<style lang="scss" scoped>
.van-submit-bar__bar{
  justify-content: space-between;
  padding-left:12px;
  .van-submit-bar__text{
    text-align: left;
    font-size:13px;
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:19px;
  }
  .van-submit-bar__price{
font-size:15px;
font-family:PingFangSC-Medium;
font-weight:500;
color:rgba(255,118,14,1);
line-height:21px;
  }
}
.van-submit-bar__button{
  width: 130px;
  // background:url('../../../assets/images/goods/bg1.png') no-repeat;
  background-position: center center;
  background-size: cover;
}
.footer{
    position: fixed;
    bottom: 0;
    height:40px;
    font-size:14px;
    font-family:PingFangSC-Medium;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:40px;
    text-align: center;
}
.goods{
  padding:12px;
  background: #fff;
  .goods-item{
    margin-bottom:20px;
  }
  .goods-img{
    width: 85px;
    height: 85px;
    margin-right:7px;
  }
  .title{
    height:auto;
    font-size:12px;
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:17px;
  }
  .goods-sku{
    height:14px;
    font-size:10px;
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:14px;
    margin:10px 0 6px;
  }
  .money{
    height:21px;
    font-size:15px;
    font-family:PingFangSC-Medium;
    font-weight:500;
    color:rgba(255,118,14,1);
    line-height:21px;
  }
}
.pab30{
  padding-bottom:15px;
}
.van-field__control{
  width:65vw;
}
.textarea-box{
  align-items: flex-start;
  .van-cell{
    padding-top:0;
  }
}
.goods2{
  background:#fff;
  padding:12px 12px 0;
  margin-top:12px;
}
  // .van-stepper__input{
  //   background:none!important;
  // }
</style>

